interface OnboardingProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

export function OnboardingProgressBar({
  currentStep,
  totalSteps,
}: OnboardingProgressBarProps) {
  const progressPercentage = (currentStep / totalSteps) * 100;

  return (
    <div className="flex justify-center w-full rounded-full">
      <div className="h-2 bg-[#E4E7EC] mt-4 w-[80%] rounded-full">
        <div
          className="h-full bg-bg-brand-solid transition-all duration-300 ease-out w-[80%] rounded-full"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
    </div>
  );
}
